export default __webpack_public_path__ + "static/media/email-icon.a9406d6e.svg";